import { Icon } from '@/components'
import { SOCIAL_LINKS } from '@/config/global-config'

export const SOCIAL_LINKS_TOP = [
  { Icon: Icon.Facebook, link: SOCIAL_LINKS.facebook, alt: 'facebook' },
  { Icon: Icon.Youtube, link: SOCIAL_LINKS.youtube, alt: 'youtube' },
]
export const FACEBOOK_APP_ID = '562316076176913'
export const E_COMMERCE_PLATFORM_SHOP = {
  shopee: 'https://shopee.vn/hydra.studio/',
  tiktok: 'https://www.tiktok.com/@heil.hydra.official',
  tiktok_shop: 'https://vt.tiktok.com/ZSa6159LX/?page=TikTokShop',
}
